import clock from '~/assets/icons/clock.svg';

import { useEffect, useMemo, useState } from 'react';
import { rage } from '~/rage';
import { formatTime } from '~/shared';
import {
	StyledContainer,
	StyledIconContainer,
	StyledTimeContainer,
	StyledTimerText,
} from './HeadInfoTimer.styled';

interface IHeadInfoTimer extends React.HTMLAttributes<HTMLDivElement> {
	icon: string | undefined;
	color: string;
	invert?: boolean;
	duration: number;
}

const HeadInfoTimer: React.FC<IHeadInfoTimer> = ({
	icon,
	color,
	invert,
	duration,
}: IHeadInfoTimer) => {
	const [timeLeft, setTimeLeft] = useState(duration);

	useEffect(() => {
		setTimeLeft(duration);
	}, [duration]);

	useEffect(() => {
		if (timeLeft <= 0) {
			rage.game.resetActivityTimer();
			return;
		}

		const timeout = setTimeout(
			() => setTimeLeft((timeLeft) => timeLeft - 1000),
			1000,
		);
		return () => clearTimeout(timeout);
	}, [timeLeft]);

	const timeString = useMemo(
		() => formatTime(Math.max(timeLeft, 0), '{mm}:{ss}'),
		[timeLeft],
	);

	return (
		<StyledContainer className={'timer'}>
			<StyledIconContainer $icon={{ icon, color, invert }}>
				<img
					src={icon}
					width={16}
					height={16}
					style={{
						filter: invert ? 'invert(100%)' : 'invert(0)',
					}}
				/>
			</StyledIconContainer>
			<StyledTimeContainer>
				<img src={clock} style={{ filter: 'invert(100%)' }} />
				<StyledTimerText>{timeString}</StyledTimerText>
			</StyledTimeContainer>
		</StyledContainer>
	);
};

export { HeadInfoTimer };
